/**
 * Distributeur — déclenche la présentation à l'arrivée dans le champ.
 *
 * Tout le mouvement est décrit en CSS ; ce fichier ne fait que poser data-vu
 * au bon moment, et une seule fois. L'état masqué du départ n'existe que sous
 * html.oyw-apparition : sans JavaScript, ou si le visiteur refuse les
 * animations, le distributeur s'affiche posé, sans rien perdre.
 */
(() => {
  const vues = [...document.querySelectorAll('[data-oyw-distributeur]')];
  if (vues.length === 0) return;

  if (!('IntersectionObserver' in window)) {
    vues.forEach((vue) => vue.setAttribute('data-vu', ''));
    return;
  }

  const guetteur = new IntersectionObserver(
    (entrees) => {
      entrees.forEach((entree) => {
        if (!entree.isIntersecting) return;
        entree.target.setAttribute('data-vu', '');
        // L'arrivée ne se joue qu'une fois : on cesse de surveiller.
        guetteur.unobserve(entree.target);
      });
    },
    { threshold: 0.3 },
  );

  vues.forEach((vue) => guetteur.observe(vue));
})();
